import { Button } from 'common';
import { goBack } from 'connected-react-router';
import React from 'react';
import { useDispatch } from 'react-redux';
function CartBackButton() {
    const dispatch = useDispatch();
    return (React.createElement(Button, { type: "action", style: "secondary", onClick: () => dispatch(goBack()) }, "Tilbake til handelen"));
}
export default CartBackButton;
